import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ChevronRight.svg",
  "use": "ChevronRight.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"ChevronRight.svg\"><path d=\"M28.4276,48.4568a2.0016,2.0016,0,0,1-2.8324-2.829l13.6064-13.59-13.6064-13.59a2.0016,2.0016,0,1,1,2.8324-2.829L43.45,30.6233a1.9984,1.9984,0,0,1,0,2.8291Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol